import { render, staticRenderFns } from "./UnsupportedBanksMessagePage.vue?vue&type=template&id=3967fddb&scoped=true&"
import script from "./UnsupportedBanksMessagePage.vue?vue&type=script&lang=js&"
export * from "./UnsupportedBanksMessagePage.vue?vue&type=script&lang=js&"
import style0 from "./UnsupportedBanksMessagePage.vue?vue&type=style&index=0&id=3967fddb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3967fddb",
  null
  
)

export default component.exports